import styles from './style.module.scss';

interface Props {
    className?: string;
    width?: number | string;
    height?: number | string;
    radius?: number | string;
};

const toCssSize = (value?: number | string) =>
    typeof value === 'number' ? `${value}px` : value;

function Skeleton(props: Props) {
    const { width, height, radius, className } = props;

    return (
        <span
            aria-hidden='true'
            className={`${styles.skeleton}${className ? ` ${className}` : ''}`}
            style={{
                width: toCssSize(width),
                height: toCssSize(height),
                borderRadius: toCssSize(radius),
            }}
        />
    );
};

export default Skeleton;
